import { render, staticRenderFns } from "./ChatGroup.vue?vue&type=template&id=5118d18c&"
import script from "./ChatGroup.vue?vue&type=script&lang=js&"
export * from "./ChatGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports